import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconButtons", "i18nKey", "children"];
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { View } from 'foundations-components/transitional/components/View';
import styled from 'styled-components';
import { PopoverBodyLiteIconElements } from '../constants/popover';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IconDivider = styled.div.withConfig({
  displayName: "PopoverBodyLiteBase__IconDivider",
  componentId: "yknlo8-0"
})(({
  theme
}) => ({
  borderInlineStartWidth: theme.borderWidth['100'],
  borderInlineStartStyle: 'solid',
  borderInlineStartColor: theme.color['border-core-default'],
  display: 'inline-block',
  height: '24px',
  marginBlock: theme.space['100']
}));
const renderIconButtons = (iconButtons, i18nKey, includeTrailingDivider = false) => {
  const handleMouseDown = evt => {
    // Prevent default to avoid blurring the editor in FF
    // see https://git.hubteam.com/HubSpot/rich-text-lib/issues/344
    evt.preventDefault();
  };
  return iconButtons.map(({
    iconName,
    onClick
  }, idx) => {
    const showDivider = idx < iconButtons.length - 1 || includeTrailingDivider;
    const key = `popover-lite-icon-button-${iconName}`;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        maxInlineSize: "32px",
        paddingBlock: "100",
        children: /*#__PURE__*/_jsx(IconButton, {
          "data-test-id": key,
          use: "transparent",
          placement: "bottom",
          size: "medium",
          padding: "0",
          tooltip: I18n.text(i18nKey(iconName)),
          onClick: onClick,
          onMouseDown: handleMouseDown,
          children: /*#__PURE__*/_jsx(IconHolder, {
            icon: PopoverBodyLiteIconElements[iconName]
          })
        }, key)
      }), showDivider && /*#__PURE__*/_jsx(IconDivider, {})]
    });
  });
};
function PopoverBodyLiteBase(props) {
  const {
      iconButtons,
      i18nKey,
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(Flex, Object.assign({}, rest, {
    padding: "100",
    tabIndex: -1,
    children: [renderIconButtons(iconButtons, i18nKey, !!children), children]
  }));
}
PopoverBodyLiteBase.displayName = 'PopoverBodyLiteBase';
export default PopoverBodyLiteBase;